<template>
  <div class="products-errors-view">
    <table>
      <thead>
        <tr>
          <th>Wann</th>
          <th>Warum</th>
          <th>Wo</th>
          <th>Genaueres</th>
        </tr>
      </thead>
      <tbody  v-if="productErrors[0] && productErrors[0].entries">
        <tr
          v-for="error in productErrors[0].entries"
          :key="error.occuredAt"
        >
          <td>{{error.occurredAt}}</td>
          <td>{{error.type}}</td>
          <td>{{error.step}}</td>
          <td>{{error.message}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import Authentication from '@/mixins/Authentication';
import productErrorsQuery
  from '@/api/queries/product-errors.graphql';

export default {
  name: 'products-errors-view',
  mixins: [
    Authentication,
  ],
  apollo: {
    productErrors: {
      query: productErrorsQuery,
      variables() {
        return {
          search: this.$attrs.product.articleNumber,
        };
      },
      fetchPolicy: 'network-only',
      loadingKey: 'loading',
      skip() {
        return !this.isAuthenticated;
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// ErrorsView.vue?0bff89ad